module.exports = __webpack_public_path__ + "img/cvs-active.c9d0ac86.svg";